/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetItemsR200ResponseInnerStoreCategoryEnum = {
    Avatar: 'avatar',
    Clothes: 'clothes',
    HatsAndWigs: 'hats_and_wigs',
    Accessories: 'accessories',
    Scenes: 'scenes',
    Background: 'background'
};
/**
 * Check if a given object implements the GetItemsR200ResponseInner interface.
 */
export function instanceOfGetItemsR200ResponseInner(value) {
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isHidden' in value) || value['isHidden'] === undefined)
        return false;
    if (!('locizeKey' in value) || value['locizeKey'] === undefined)
        return false;
    if (!('maxGrade' in value) || value['maxGrade'] === undefined)
        return false;
    if (!('minGrade' in value) || value['minGrade'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('storeCategory' in value) || value['storeCategory'] === undefined)
        return false;
    return true;
}
export function GetItemsR200ResponseInnerFromJSON(json) {
    return GetItemsR200ResponseInnerFromJSONTyped(json, false);
}
export function GetItemsR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'category': json['category'],
        'id': json['id'],
        'isHidden': json['isHidden'],
        'locizeKey': json['locizeKey'],
        'maxGrade': json['maxGrade'],
        'minGrade': json['minGrade'],
        'name': json['name'],
        'price': json['price'],
        'storeCategory': json['storeCategory'],
    };
}
export function GetItemsR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'category': value['category'],
        'id': value['id'],
        'isHidden': value['isHidden'],
        'locizeKey': value['locizeKey'],
        'maxGrade': value['maxGrade'],
        'minGrade': value['minGrade'],
        'name': value['name'],
        'price': value['price'],
        'storeCategory': value['storeCategory'],
    };
}
